import { useSelector } from 'react-redux';
import Global from '../../../store/global-selectors';

export const useOneOrMoreOrAllOrderSelectedDisabled = () => {
  const areAllSelected = useSelector(Global.selectSelectedOrdersAreAllOrdersSelected);
  const selectedOrdersCount = useSelector(Global.selectSelectedOrdersCount) || 0;
  return selectedOrdersCount === 0 && !areAllSelected;
};
